import { render } from "./InvoiceAdd.vue?vue&type=template&id=4fcef17c&ts=true"
import script from "./InvoiceAdd.vue?vue&type=script&lang=ts"
export * from "./InvoiceAdd.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__